(function ($) {

    if (typeof Drupal !== "undefined") {
        var pathTheme = "/themes/algusTrucks1";
    } else {
        var pathTheme = "";
    }
    var pathLogo = "/sites/default/files/logo-04_1.png",
        printPhones = "+7 (351) 751-40-60",
        printEmails = "nsteh@list.ru",
        printLocation = "г. Челябинск, Комсомольский проспект 33Д - 53",
        printYears = new Date().getFullYear(),
        printCopyright = "ООО «Уралтехцентр»";

    $(".field-print a").on("click", function (e) {
        e.preventDefault();
        myPrint();
    });

    function myPrint() {
        $("body").once().prepend(`
            <link rel="stylesheet" href="${pathTheme}/css/style1/11-print-page_style1.css">
            <div style="display: none;" class="print-header">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="logo">
                            <img class="img-responsive" src="${pathLogo}" />
                        </td>
                        <td class="phones">
                            ${printPhones}
                        </td>
                        <td class="email">
                            ${printEmails}
                        </td>
                    </tr>
                </table>
            </div>`).append(
            `<div class="print-footer" style="display: none;">
                <div>
                  <div class="copyright">${printCopyright},${printYears}</div>
                  <div class="location">${printLocation}</div>
                </div>
                <div>
                  <div class="phone">${printPhones}</div>
                  <div class="email">${printEmails}</div>
                </div>
            </div>`
        );

        $("img").each(function () {
            $(this).attr("src", $(this).attr("data-src"));
        });
        setTimeout(function(){
            window.print();
        }, 1000);
    }

})(jQuery);
